const initialState = {
    AdminProfile: null,
}

const ProfileReducer = (state=initialState,{type,payload}) =>{
    switch(type){
        case "ADMIN_PROFILE":
            return {
                ...state,
                AdminProfile:payload.data,
            }
        case "Update_Profile":
            return {
                ...state,
                AdminProfile:payload.data,
            }
        default:
            return state;
    }
}

export default ProfileReducer;